export const SET_SPIN_COMPANY_ID = 'SET_SPIN_COMPANY_ID';
